(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDnD"), require("ReactDnDHTML5Backend"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDnD", "ReactDnDHTML5Backend"], factory);
	else if(typeof exports === 'object')
		exports["ReactTags"] = factory(require("React"), require("ReactDnD"), require("ReactDnDHTML5Backend"));
	else
		root["ReactTags"] = factory(root["React"], root["ReactDnD"], root["ReactDnDHTML5Backend"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__14__, __WEBPACK_EXTERNAL_MODULE__36__) {
return 